
import React from 'react';
import { CheckCircle2 } from 'lucide-react';

interface FormSuccessMessageProps {
  title: string;
  message: string;
}

const FormSuccessMessage: React.FC<FormSuccessMessageProps> = ({ title, message }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center animate-fade-in">
      <CheckCircle2 className="w-16 h-16 text-green-500 mb-6 animate-scale-in" />
      <h3 className="text-xl md:text-2xl font-bold text-white mb-4">
        {title}
      </h3>
      <p className="text-gray-300">
        {message}
      </p>
    </div>
  );
};

export default FormSuccessMessage;
